
import {
	applyMiddleware
	, compose
	, createStore
} from 'redux';
import thunkMiddleware from 'redux-thunk';
import { routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from 'history';
// import { browserHistory } from "react-router";

import crashReporter from "./middleware/Sentry";
import AJAXMiddleware from "./middleware/AJAX";
import AnalyticsMiddleware from './middleware/Analytics';
import NotifyMiddleware from "./middleware/Notifications";
import makeRootReducer from "./reducers/reducer";
import config from "utils/appConfig";


function makeStore(initialState = {}, history = null) {
	let routerHistory = history;

	if (!history) {
		routerHistory = createBrowserHistory();
	}
	// -----------------------------------
	// Middleware Configuration
	// -----------------------------------
	let middleware = [
		thunkMiddleware
		, routerMiddleware(routerHistory)
		, AJAXMiddleware
		, AnalyticsMiddleware
		, NotifyMiddleware
		, crashReporter
	];

	// -----------------------------------
	// Store Enhancers
	// -----------------------------------
	let enhancers = []
		, composeEnhancers = compose
		;

	if(window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__){
		if(config.devToolsSettings){
			composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(config.devToolsSettings);
		} else {
			composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
		}
	}

	// -----------------------------------
	// Store Instantiation and HMR Setup
	// -----------------------------------
	let store = createStore(
		makeRootReducer(null, routerHistory),
		initialState,
		composeEnhancers(
			applyMiddleware(...middleware),
			...enhancers
		)
	);

	return store;
}

export default makeStore;
